import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiAddress\GetWikiAddressByIdController::__invoke
* @see app/Http/Controllers/WikiAddress/GetWikiAddressByIdController.php
* @route '/api/wiki-address/{wiki_address}'
*/
const GetWikiAddressByIdController = (args: { wiki_address: string | { id: string } } | [wiki_address: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiAddressByIdController.url(args, options),
    method: 'get',
})

GetWikiAddressByIdController.definition = {
    methods: ["get","head"],
    url: '/api/wiki-address/{wiki_address}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiAddress\GetWikiAddressByIdController::__invoke
* @see app/Http/Controllers/WikiAddress/GetWikiAddressByIdController.php
* @route '/api/wiki-address/{wiki_address}'
*/
GetWikiAddressByIdController.url = (args: { wiki_address: string | { id: string } } | [wiki_address: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { wiki_address: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { wiki_address: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            wiki_address: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        wiki_address: typeof args.wiki_address === 'object'
        ? args.wiki_address.id
        : args.wiki_address,
    }

    return GetWikiAddressByIdController.definition.url
            .replace('{wiki_address}', parsedArgs.wiki_address.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiAddress\GetWikiAddressByIdController::__invoke
* @see app/Http/Controllers/WikiAddress/GetWikiAddressByIdController.php
* @route '/api/wiki-address/{wiki_address}'
*/
GetWikiAddressByIdController.get = (args: { wiki_address: string | { id: string } } | [wiki_address: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiAddressByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiAddress\GetWikiAddressByIdController::__invoke
* @see app/Http/Controllers/WikiAddress/GetWikiAddressByIdController.php
* @route '/api/wiki-address/{wiki_address}'
*/
GetWikiAddressByIdController.head = (args: { wiki_address: string | { id: string } } | [wiki_address: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetWikiAddressByIdController.url(args, options),
    method: 'head',
})

export default GetWikiAddressByIdController